import { render, staticRenderFns } from "./ButtonsCounter.vue?vue&type=template&id=2b774e86"
import script from "./ButtonsCounter.vue?vue&type=script&lang=js"
export * from "./ButtonsCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports